import { DateFormatType, DateFormatOptions } from '../pages/dsn-list/types/dsntable.types';

import {
  DEFAULT_DATE_OPTIONS,
  DEFAULT_DATE_FORMAT_OPTIONS,
  DATETIME_FORMAT_OPTIONS,
  DEFAULT_LOCALE,
} from '../pages/dsn-list/constants/dsntable.constants';

export const formatDateString = (
  dateString: string,
  options: DateFormatOptions = DEFAULT_DATE_OPTIONS,
) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const locale = options.locale ?? DEFAULT_LOCALE;

  const formatOptions =
    options.type === DateFormatType.DATETIME
      ? DATETIME_FORMAT_OPTIONS
      : DEFAULT_DATE_FORMAT_OPTIONS;

  return new Intl.DateTimeFormat(locale, formatOptions).format(date);
};

export const formatTimeString = (dateString: string) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  return new Intl.DateTimeFormat(DEFAULT_LOCALE, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date);
};

export function formatDate(dateString: string): string {
  if (!dateString) return '-';

  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
